(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var scrollBus = (function () {
    var subs = {};
    var ticking = false;
    var wired = false;
    function run() {
      ticking = false;
      for (var k in subs) subs[k]();
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(run); } }
    return {
      set: function (name, fn) {
        if (!fn) { delete subs[name]; return; }
        subs[name] = fn;
        if (!wired && 'requestAnimationFrame' in window) {
          wired = true;
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll, { passive: true });
        }
        fn();
      }
    };
  })();

  function initReveals() {
    var els = document.querySelectorAll('.us-root [data-us-reveal]:not([data-us-reveal-wired])');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) return;

    var REVEAL_STEP = 70;
    var REVEAL_STEPS_MAX = 3;

    function showNow(el) {
      el.style.setProperty('--us-reveal-delay', '0ms');
      el.classList.add('is-revealed', 'is-revealed-instant');
    }

    var ios = {};
    function observerFor(pct) {
      if (!ios[pct]) {
        ios[pct] = new IntersectionObserver(function (entries) {
          var arriving = [];
          entries.forEach(function (entry) {
            var rect = entry.boundingClientRect;
            if (!entry.isIntersecting && rect.bottom >= 0) return;
            ios[pct].unobserve(entry.target);
            var vh = window.innerHeight || document.documentElement.clientHeight;
            var line = Math.max(0, vh * (1 - pct / 100) - rect.height * 0.1);
            if (rect.bottom < 0 || rect.top < line - vh * 0.25) showNow(entry.target);
            else arriving.push(entry.target);
          });
          arriving.sort(function (a, b) {
            return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
          });
          arriving.forEach(function (el, i) {
            el.style.setProperty('--us-reveal-delay', (Math.min(i, REVEAL_STEPS_MAX) * REVEAL_STEP) + 'ms');
            el.classList.add('is-revealed');
          });
        }, { rootMargin: '0px 0px -' + pct + '% 0px', threshold: 0.1 });
      }
      return ios[pct];
    }

    els.forEach(function (el) {
      el.setAttribute('data-us-reveal-wired', '');
      var at = parseFloat(el.getAttribute('data-us-reveal-at'));
      if (!(at >= 0 && at < 90)) at = 10;
      observerFor(at).observe(el);
    });

    scrollBus.set('revealPast', function () {
      var pending = document.querySelectorAll('.us-root [data-us-reveal][data-us-reveal-wired]:not(.is-revealed)');
      if (!pending.length) {
        scrollBus.set('revealPast', null);
        return;
      }
      Array.prototype.forEach.call(pending, function (el) {
        if (el.getBoundingClientRect().bottom < 0) showNow(el);
      });
    });
  }

  function marketRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '');
  }

  function formPairs(form) {
    var out = [];
    var els = form.elements;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.name || el.disabled) continue;
      var type = (el.type || '').toLowerCase();
      if (type === 'submit' || type === 'button' || type === 'reset' || type === 'file') continue;
      if ((type === 'checkbox' || type === 'radio') && !el.checked) continue;
      out.push([el.name, el.value]);
    }
    return out;
  }

  function buildCartItems(form) {
    var indexed = {};
    var order = [];
    var single = { properties: {} };

    formPairs(form).forEach(function (pair) {
      var name = pair[0];
      var value = pair[1];

      var multi = name.match(/^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?$/);
      if (multi) {
        var n = multi[1];
        if (!indexed[n]) { indexed[n] = { properties: {} }; order.push(n); }
        if (multi[2] === 'properties' && multi[3]) indexed[n].properties[multi[3]] = value;
        else indexed[n][multi[2]] = value;
        return;
      }

      var prop = name.match(/^properties\[(.+)\]$/);
      if (prop) { single.properties[prop[1]] = value; return; }

      if (name === 'id' || name === 'quantity' || name === 'selling_plan') single[name] = value;
    });

    var lines = order.length
      ? order.map(function (n) { return indexed[n]; })
      : [single];

    return lines
      .filter(function (line) { return line.id; })
      .map(function (line) {
        var item = { id: Number(line.id), quantity: Number(line.quantity) || 1 };
        if (line.selling_plan) item.selling_plan = Number(line.selling_plan);
        item.properties = line.properties;
        return item;
      });
  }

  function announceCartCleared() {
    var pending = [];
    if (window.CustomEvent) {
      document.dispatchEvent(new CustomEvent('us:cart-cleared', { detail: { pending: pending } }));
    }
    return Promise.all(pending).catch(function () { });
  }

  var buyWired = false;
  function initBuy() {
    if (buyWired) return;
    buyWired = true;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.us-buy-form');
      if (!form) return;

      if (!window.fetch) return;
      var items = buildCartItems(form);
      if (!items.length) return;

      e.preventDefault();
      var btn = form.querySelector('button');
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        var spinner = btn.querySelector('.us-btn__spinner');
        if (spinner) {
          var padL = parseFloat(window.getComputedStyle(btn).paddingLeft) || 24;
          spinner.style.left = (padL / 2) + 'px';
        }
      }
      function clearBusy() {
        if (!btn) return;
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      }

      var root = marketRoot();

      fetch(root + '/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(announceCartCleared)
        .then(function () {
          return fetch(root + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          window.location.assign(root + '/checkout');
        })
        .catch(function () {
          clearBusy();
          form.submit();
        });
    });
  }

  function initStickyCta() {
    var bar = document.querySelector('[data-us-sticky-cta]');
    if (!bar) { scrollBus.set('stickycta', null); return; }
    var hero = document.querySelector('.us-hero');
    scrollBus.set('stickycta', function () {
      var shown = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
      bar.classList.toggle('is-shown', shown);
    });
  }

  function initHiwStack() {
    var section = document.querySelector('.us-hiw');
    if (!section) { scrollBus.set('hiwstack', null); return; }
    var track = section.querySelector('[data-us-hiw-track]');
    var stage = section.querySelector('.us-hiw__stage');
    var cards = Array.prototype.slice.call(section.querySelectorAll('.us-hiw__card'));
    if (!track || !stage || cards.length < 2) { scrollBus.set('hiwstack', null); return; }
    if (reduce) { section.classList.remove('is-stack'); scrollBus.set('hiwstack', null); return; }

    section.classList.add('is-stack');
    var N = cards.length;
    var REVEAL_SPAN = 0.82;
    var geo = { stageH: 0, stageTop: 0, pinRange: 1, bar: 56 };

    function barH() {
      return parseFloat(getComputedStyle(section).getPropertyValue('--_bar-h')) || 56;
    }

    function measure() {
      cards.forEach(function (c) { c.style.transform = 'none'; });
      var maxH = 0;
      cards.forEach(function (c) { var h = c.offsetHeight; if (h > maxH) maxH = h; });
      geo.bar = barH();
      var stageH = (N - 1) * geo.bar + maxH;
      stage.style.height = stageH + 'px';
      var revealPer = Math.max(window.innerHeight * 0.5, 360);
      track.style.height = (stageH + N * revealPer) + 'px';
      geo.stageH = stageH;
      geo.stageTop = parseFloat(getComputedStyle(stage).top) || 0;
      geo.pinRange = track.offsetHeight - stageH;
    }

    function targetProgress() {
      var pinned = geo.stageTop - track.getBoundingClientRect().top;
      return geo.pinRange > 0 ? Math.min(1, Math.max(0, pinned / geo.pinRange)) : 0;
    }

    function render(p) {
      for (var i = 0; i < N; i++) {
        var toY = i * geo.bar, y;
        if (i === 0) {
          y = toY;
        } else {
          var start = (i - 1) / (N - 1) * REVEAL_SPAN;
          var end = i / (N - 1) * REVEAL_SPAN;
          var local = end > start ? (p - start) / (end - start) : 1;
          local = Math.min(1, Math.max(0, local));
          local = 1 - Math.pow(1 - local, 3);
          y = geo.stageH + (toY - geo.stageH) * local;
        }
        cards[i].style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      }
    }

    var LERP = 0.14, cur = 0, raf = null;
    function tick() {
      var tgt = targetProgress();
      cur += (tgt - cur) * LERP;
      if (Math.abs(tgt - cur) < 0.0008) { cur = tgt; render(cur); raf = null; return; }
      render(cur);
      raf = requestAnimationFrame(tick);
    }
    function kick() { if (raf == null) raf = requestAnimationFrame(tick); }

    measure();
    cur = targetProgress(); render(cur);
    var rz;
    window.addEventListener('resize', function () {
      if (rz) return;
      rz = requestAnimationFrame(function () { rz = 0; measure(); cur = targetProgress(); render(cur); });
    });
    scrollBus.set('hiwstack', kick);
  }

  function initNavTone() {
    var root = document.querySelector('.us-header-root[data-us-nav-auto]');
    var bar = root && root.querySelector('.us-header__bar');
    if (!bar) { scrollBus.set('navtone', null); return; }
    var zones = Array.prototype.slice.call(document.querySelectorAll('[data-us-nav-tone="dark"]'));

    scrollBus.set('navtone', function () {
      bar.classList.toggle('is-pinned', window.scrollY > 36);
      var probe = bar.getBoundingClientRect().bottom - 8;
      var dark = false;
      for (var i = 0; i < zones.length; i++) {
        var r = zones[i].getBoundingClientRect();
        if (r.top <= probe && r.bottom > probe) { dark = true; break; }
      }
      bar.classList.toggle('us-header__bar--dark', dark);
      bar.classList.toggle('us-header__bar--light', !dark);
    });
  }

  var ddDocWired = false;
  function initDropdown() {
    var dds = Array.prototype.slice.call(document.querySelectorAll('.us-header__dd'));
    if (!dds.length) return;
    dds.forEach(function (dd) {
      var trigger = dd.querySelector('.us-header__ddtrigger');
      if (!trigger || trigger.hasAttribute('data-us-dd-wired')) return;
      trigger.setAttribute('data-us-dd-wired', '');
      trigger.addEventListener('click', function () {
        var open = dd.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    if (ddDocWired) return;
    ddDocWired = true;
    function closeAll(except) {
      document.querySelectorAll('.us-header__dd.is-open').forEach(function (dd) {
        if (dd === except) return;
        dd.classList.remove('is-open');
        var t = dd.querySelector('.us-header__ddtrigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) { closeAll(e.target.closest('.us-header__dd')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  function initHeroSpotlight() {
    var hero = document.querySelector('.us-hero');
    var reveal = hero && hero.querySelector('.us-hero__reveal');
    if (!hero || !reveal || reduce || hero.hasAttribute('data-us-spot-wired')) return;
    hero.setAttribute('data-us-spot-wired', '');

    var pending = null, raf = null;
    function apply() {
      raf = null;
      if (!pending) return;
      var r = hero.getBoundingClientRect();
      reveal.style.setProperty('--us-hero-spot-x', ((pending.x - r.left) / r.width * 100).toFixed(2) + '%');
      reveal.style.setProperty('--us-hero-spot-y', ((pending.y - r.top) / r.height * 100).toFixed(2) + '%');
    }
    hero.addEventListener('pointermove', function (e) {
      pending = { x: e.clientX, y: e.clientY };
      if (raf == null) raf = requestAnimationFrame(apply);
    });
  }

  function initFooterSpotlight() {
    var footer = document.querySelector('.us-footer');
    var spot = footer && footer.querySelector('.us-footer__spot');
    if (!footer || !spot || reduce || footer.hasAttribute('data-us-spot-wired')) return;
    footer.setAttribute('data-us-spot-wired', '');

    var pending = null, raf = null;
    function apply() {
      raf = null;
      if (!pending) return;
      var r = footer.getBoundingClientRect();
      spot.style.setProperty('--us-footer-spot-x', ((pending.x - r.left) / r.width * 100).toFixed(2) + '%');
      spot.style.setProperty('--us-footer-spot-y', ((pending.y - r.top) / r.height * 100).toFixed(2) + '%');
    }
    footer.addEventListener('pointermove', function (e) {
      pending = { x: e.clientX, y: e.clientY };
      if (raf == null) raf = requestAnimationFrame(apply);
    });
  }

  function initHeaderPanel() {
    var d = document.querySelector('.us-header__disclosure');
    if (!d || d.hasAttribute('data-us-panel-wired')) return;
    d.setAttribute('data-us-panel-wired', '');
    var bar = document.querySelector('.us-header__bar');
    var wasDark = false;
    d.addEventListener('toggle', function () {
      document.body.style.overflow = d.open ? 'hidden' : '';
      if (bar) {
        if (d.open) {
          wasDark = bar.classList.contains('us-header__bar--dark');
          bar.classList.remove('us-header__bar--dark');
          bar.classList.add('us-header__bar--light');
        } else if (wasDark) {
          bar.classList.remove('us-header__bar--light');
          bar.classList.add('us-header__bar--dark');
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) d.open = false;
    });
  }

  function initGenomeSunburst() {
    var NS = 'http://www.w3.org/2000/svg';
    var G = window.US_PANEL_GROUPS;
    var GROUP_ORDER = (G && G.order) || ['Cancer', 'Cardiac', 'Additional'];
    var GROUP_COLOR = (G && G.color) || { Cancer: '#33382c', Cardiac: '#576049', Additional: '#848c73' };
    function groupOf(name) {
      if (G && G.of) return G.of(name);
      var n = (name || '').toLowerCase();
      if (n.indexOf('cancer') > -1) return 'Cancer';
      if (n.indexOf('heart') > -1 || n.indexOf('cardio') > -1 || n.indexOf('rhythm') > -1 || n.indexOf('circulation') > -1) return 'Cardiac';
      return 'Additional';
    }

    Array.prototype.forEach.call(document.querySelectorAll('.us-sunburst'), function (root) {
      var svg = root.querySelector('.us-sunburst__svg');
      if (!svg || root.hasAttribute('data-us-sunburst-wired')) return;
      root.setAttribute('data-us-sunburst-wired', '');
      var cats;
      if (root.getAttribute('data-us-sunburst-source') === 'panel' && window.US_PANEL && window.US_PANEL.categories) {
        cats = window.US_PANEL.categories.map(function (c) { return { name: c.name, count: c.count, color: c.color }; });
      } else {
        var dataEl = root.querySelector('.us-sunburst__data');
        if (!dataEl) return;
        try { cats = JSON.parse(dataEl.textContent); } catch (e) { return; }
      }
      cats = cats.filter(function (c) { return c && c.count > 0; });
      if (!cats.length) return;

      var flat = root.getAttribute('data-us-sunburst-flat') === 'true';
      var ORDER = flat ? cats.map(function (c) { return c.name; }) : GROUP_ORDER;
      cats.forEach(function (c) { c.group = flat ? c.name : groupOf(c.name); });
      cats.sort(function (a, b) { return ORDER.indexOf(a.group) - ORDER.indexOf(b.group); });
      var groupsData = ORDER.map(function (g) {
        var gc = cats.filter(function (c) { return c.group === g; });
        return { name: (!flat && G && G.label) ? G.label(g) : g, color: flat ? (gc[0] && gc[0].color) : GROUP_COLOR[g], cats: gc, count: gc.reduce(function (s, c) { return s + c.count; }, 0) };
      }).filter(function (g) { return g.count > 0; });

      var total = cats.reduce(function (s, c) { return s + c.count; }, 0);

      var CX = 180, CY = 180, GRP_GAP = 4, CAT_GAP = 1.4;
      var GRP_IN = 80, GRP_OUT = 102, CAT_IN = 107, CAT_OUT = 135, TICK_IN = 139, TICK_OUT = 165;
      var nCats = cats.length, nGroups = groupsData.length;
      if (flat) CAT_IN = GRP_IN;

      var swFrom = parseFloat(root.getAttribute('data-sweep-from'));
      var swTo = parseFloat(root.getAttribute('data-sweep-to'));
      var partial = isFinite(swFrom) && isFinite(swTo) && (swTo - swFrom) > 30 && (swTo - swFrom) < 360;
      var arcStart = partial ? swFrom : 0;
      var arcSpan = partial ? (swTo - swFrom) : 360;
      var grpGaps = partial ? (nGroups - 1) : nGroups;
      var unit = (arcSpan - GRP_GAP * grpGaps - CAT_GAP * (nCats - nGroups)) / total;
      if (!(unit > 0)) return;

      function polar(r, a) { var rad = a * Math.PI / 180; return [CX + r * Math.sin(rad), CY - r * Math.cos(rad)]; }
      function f(p) { return p[0].toFixed(2) + ' ' + p[1].toFixed(2); }
      function sector(a0, a1, ri, ro) {
        var large = (a1 - a0) > 180 ? 1 : 0;
        return 'M' + f(polar(ro, a0)) + 'A' + ro + ' ' + ro + ' 0 ' + large + ' 1 ' + f(polar(ro, a1)) +
               'L' + f(polar(ri, a1)) + 'A' + ri + ' ' + ri + ' 0 ' + large + ' 0 ' + f(polar(ri, a0)) + 'Z';
      }
      function el(name, attrs) { var e = document.createElementNS(NS, name); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }

      while (svg.firstChild) svg.removeChild(svg.firstChild);

      var guides = el('g', { 'class': 'us-sunburst__guides', 'aria-hidden': 'true' });
      (flat ? [CAT_OUT, TICK_OUT] : [GRP_OUT, CAT_OUT, TICK_OUT]).forEach(function (r) {
        guides.appendChild(el('circle', { cx: CX, cy: CY, r: r }));
      });
      svg.appendChild(guides);

      if (partial) {
        var openFrom = swTo + GRP_GAP, openTo = swFrom + 360 - GRP_GAP;
        var open = el('g', { 'class': 'us-sunburst__open', 'aria-hidden': 'true' });
        open.appendChild(el('path', { d: sector(openFrom, openTo, GRP_IN, TICK_OUT), 'class': 'us-sunburst__open-face' }));
        [GRP_OUT, CAT_IN, CAT_OUT, TICK_IN].forEach(function (r) {
          var p0 = polar(r, openFrom), p1 = polar(r, openTo);
          open.appendChild(el('path', {
            d: 'M' + f(p0) + 'A' + r + ' ' + r + ' 0 ' + ((openTo - openFrom) > 180 ? 1 : 0) + ' 1 ' + f(p1),
            'class': 'us-sunburst__open-line'
          }));
        });
        svg.appendChild(open);
      }

      var catEls = [], groupEls = [], catIndex = 0, cursor = arcStart;
      groupsData.forEach(function (g, gi) {
        var groupStart = cursor;
        g.cats.forEach(function (c, k) {
          var span = c.count * unit, a0 = cursor, a1 = cursor + span;
          var arc = el('path', { d: sector(a0, a1, CAT_IN, CAT_OUT), fill: c.color, 'class': 'us-sunburst__arc', 'data-cat': catIndex, 'data-group': gi });
          var t = el('title', {}); t.textContent = c.name + ': ' + c.count + ' genes'; arc.appendChild(t);
          svg.appendChild(arc);
          var ticks = [], step = span / c.count;
          for (var i = 0; i < c.count; i++) {
            var tc = a0 + (i + 0.5) * step, p0 = polar(TICK_IN, tc), p1 = polar(TICK_OUT, tc);
            svg.appendChild(el('line', { x1: p0[0].toFixed(2), y1: p0[1].toFixed(2), x2: p1[0].toFixed(2), y2: p1[1].toFixed(2),
              stroke: c.color, 'stroke-width': 2, 'stroke-linecap': 'butt', 'class': 'us-sunburst__tick', 'data-cat': catIndex, 'data-group': gi }));
            ticks.push(svg.lastChild);
          }
          c.gIndex = catIndex;
          catEls[catIndex] = { arc: arc, ticks: ticks, group: gi, name: c.name, count: c.count };
          catIndex++;
          cursor += span;
          if (k < g.cats.length - 1) cursor += CAT_GAP;
        });
        var garc = el('path', { d: sector(groupStart, cursor, GRP_IN, GRP_OUT), fill: g.color, 'class': 'us-sunburst__grp', 'data-group': gi });
        var gt = el('title', {}); gt.textContent = g.name + ': ' + g.count + ' genes'; garc.appendChild(gt);
        if (!flat) svg.appendChild(garc);
        groupEls[gi] = { arc: garc, name: g.name, count: g.count };

        if (!partial || gi < groupsData.length - 1) cursor += GRP_GAP;
      });

      var legendUl = root.querySelector('.us-sunburst__legend');
      if (legendUl) {
        legendUl.innerHTML = '';
        groupsData.forEach(function (g, gi) {
          var gh = document.createElement('li');
          gh.className = 'us-sunburst__legend-group'; gh.setAttribute('data-group', gi); gh.setAttribute('tabindex', '0');
          gh.style.setProperty('--sw', g.color);
          var gsw = document.createElement('span'); gsw.className = 'us-sunburst__swatch'; gsw.style.setProperty('--sw', g.color);
          var gnm = document.createElement('span'); gnm.className = 'us-sunburst__legend-gname'; gnm.textContent = g.name;
          var gct = document.createElement('span'); gct.className = 'us-sunburst__legend-count'; gct.textContent = g.count;
          gh.appendChild(gsw); gh.appendChild(gnm); gh.appendChild(gct);
          legendUl.appendChild(gh);
          if (flat) return;
          g.cats.forEach(function (c) {
            var li = document.createElement('li');
            li.className = 'us-sunburst__legend-item'; li.setAttribute('data-cat', c.gIndex); li.setAttribute('data-group', gi); li.setAttribute('tabindex', '0');
            var nm = document.createElement('span'); nm.className = 'us-sunburst__legend-name'; nm.textContent = c.name;
            var ct = document.createElement('span'); ct.className = 'us-sunburst__legend-count'; ct.textContent = c.count;
            li.appendChild(nm); li.appendChild(ct);
            legendUl.appendChild(li);
          });
        });
      }

      var centerNum = root.querySelector('[data-total]');
      var centerLbl = root.querySelector('[data-total-label]');
      var totalDisplay = root.getAttribute('data-total-display') || String(total);
      if (centerNum) centerNum.textContent = totalDisplay;
      var origNum = centerNum ? centerNum.textContent : '';
      var origLbl = centerLbl ? centerLbl.textContent : '';
      var legendItems = root.querySelectorAll('.us-sunburst__legend-item');
      var legendGroups = root.querySelectorAll('.us-sunburst__legend-group');

      function paint(matchCat, matchGroup, num, lbl) {
        root.classList.add('is-focusing');
        catEls.forEach(function (c, i) { var on = matchCat(i, c); c.arc.classList.toggle('is-active', on); c.ticks.forEach(function (t) { t.classList.toggle('is-active', on); }); });
        groupEls.forEach(function (g, i) { g.arc.classList.toggle('is-active', matchGroup(i)); });
        Array.prototype.forEach.call(legendItems, function (li) { li.classList.toggle('is-active', matchCat(+li.getAttribute('data-cat'), catEls[+li.getAttribute('data-cat')])); });
        Array.prototype.forEach.call(legendGroups, function (li) { li.classList.toggle('is-active', matchGroup(+li.getAttribute('data-group'))); });
        if (centerNum) centerNum.textContent = num;
        if (centerLbl) centerLbl.textContent = lbl;
      }
      function activeByCat(ci) { paint(function (i) { return i === ci; }, function () { return false; }, catEls[ci].count, catEls[ci].name); }
      function activeByGroup(gi) { paint(function (i, c) { return c.group === gi; }, function (i) { return i === gi; }, groupEls[gi].count, groupEls[gi].name); }
      function clearActive() {
        root.classList.remove('is-focusing');
        catEls.forEach(function (c) { c.arc.classList.remove('is-active'); c.ticks.forEach(function (t) { t.classList.remove('is-active'); }); });
        groupEls.forEach(function (g) { g.arc.classList.remove('is-active'); });
        Array.prototype.forEach.call(legendItems, function (li) { li.classList.remove('is-active'); });
        Array.prototype.forEach.call(legendGroups, function (li) { li.classList.remove('is-active'); });
        if (centerNum) centerNum.textContent = origNum;
        if (centerLbl) centerLbl.textContent = origLbl;
      }

      var scrollActive = false;
      function wire(node, fn) {
        node.addEventListener('mouseenter', function () { if (!scrollActive) fn(); });
        node.addEventListener('mouseleave', function () { if (!scrollActive) clearActive(); });
        node.addEventListener('focus', fn);
        node.addEventListener('blur', function () { if (!scrollActive) clearActive(); });
      }
      catEls.forEach(function (c, ci) { wire(c.arc, function () { activeByCat(ci); }); });
      groupEls.forEach(function (g, gi) { wire(g.arc, function () { activeByGroup(gi); }); });
      Array.prototype.forEach.call(legendItems, function (li) { wire(li, function () { activeByCat(+li.getAttribute('data-cat')); }); });
      Array.prototype.forEach.call(legendGroups, function (li) { wire(li, function () { activeByGroup(+li.getAttribute('data-group')); }); });

      var track = root.querySelector('[data-us-sunburst-track]');
      var stage = root.querySelector('.us-sunburst__stage');
      var canScroll = track && stage && !reduce && 'requestAnimationFrame' in window;
      if (canScroll) {
        var busKey = 'sunburst-' + (initGenomeSunburst._n = (initGenomeSunburst._n || 0) + 1);
        var mq = window.matchMedia('(min-width: 860px)');
        var hasTail = root.classList.contains('us-sunburst--list');
        var hasSoon = !!root.querySelector('.us-sunburst__soon-item');
        var hasAct1 = root.getAttribute('data-us-sunburst-act1') !== 'false';
        var ACT1_SHARE = 0.32;
        var PRO_READ = hasAct1 ? 0.08 : 0;
        var PRO_END = hasAct1 ? ACT1_SHARE : 0;
        var SWEEP_END = hasSoon ? 0.74 : (hasTail ? 0.84 : 0.9);
        var COMPLETE_AT = hasSoon ? 0.86 : (hasTail ? 0.93 : 0.9);
        var lastSweep = -1, lastDone = null, geo = { top: 0, range: 1 };

        var introEl = root.querySelector('.us-sunburst__intro');
        var introPane = root.querySelector('.us-sunburst__intropane') || introEl;
        var introHead = root.querySelector('.us-sunburst__introhead');
        var introScroll = root.querySelector('.us-sunburst__intro-scroll');
        var legendEl = root.querySelector('.us-sunburst__legend');
        var vizEl = root.querySelector('.us-sunburst__viz');
        var lastShift = null, lastHead = null;
        var EDGE_FADE = 28;
        function syncFade(y) {
          if (!introPane || !introScroll) return;
          var paneH = introPane.clientHeight;
          var contentBottom = y + introScroll.scrollHeight;
          introPane.style.setProperty('--us-fade-top', y < -1 ? EDGE_FADE + 'px' : '0px');
          introPane.style.setProperty('--us-fade-bottom', contentBottom > paneH + 1 ? EDGE_FADE + 'px' : '0px');
        }
        function shiftCopy(y) {
          if (!introScroll || y === lastShift) return;
          lastShift = y;
          introScroll.style.transform = y ? 'translate3d(0,' + y.toFixed(1) + 'px,0)' : '';
          syncFade(y);
        }
        function shiftHead(y) {
          if (!introHead || y === lastHead) return;
          lastHead = y;
          introHead.style.transform = y ? 'translate3d(0,' + y.toFixed(1) + 'px,0)' : '';
        }
        function headCentreY() {
          var ref = introEl || introPane;
          if (!ref) return 0;
          var headH = introHead ? introHead.offsetHeight
                    : (legendEl ? legendEl.offsetTop : 0);
          var vizMid = ref.clientHeight / 2;
          if (vizEl) {
            var pr = ref.getBoundingClientRect(), vr = vizEl.getBoundingClientRect();
            vizMid = (vr.top + vr.height / 2) - pr.top;
          }
          return Math.max(0, vizMid - headH / 2);
        }

        function trackCopy(act2) {
          if (!introPane || !introScroll) return;
          var paneH = introPane.clientHeight;
          var contentH = introScroll.scrollHeight;
          var centreY = headCentreY();
          if (!act2) {
            shiftHead(centreY);
            shiftCopy(centreY);
            return;
          }

          var last = null;
          Array.prototype.forEach.call(legendGroups, function (g) {
            if (g.offsetParent !== null && g.classList.contains('is-shown')) last = g;
          });
          if (!last) {
            Array.prototype.forEach.call(legendItems, function (li) {
              if (li.classList.contains('is-shown')) last = li;
            });
          }
          var complete = root.classList.contains('is-complete');
          var revealedH = complete ? contentH
            : last ? (last.getBoundingClientRect().bottom - introScroll.getBoundingClientRect().top)
                   : 0;
          var over = Math.max(0, revealedH - (paneH - centreY));
          var headShift = Math.max(0, centreY - over);
          shiftHead(headShift);

          if (headShift > 0) { shiftCopy(headShift); return; }

          if (contentH <= paneH) { shiftCopy(0); return; }
          if (complete) {
            shiftCopy(-(contentH - paneH));
            return;
          }
          if (!last) { shiftCopy(0); return; }
          var want = (last.getBoundingClientRect().top
                      - introScroll.getBoundingClientRect().top) - paneH / 3;
          shiftCopy(-Math.min(Math.max(0, want), contentH - paneH));
        }

        var PRO_IN = 78, PRO_OUT = 165, PRO_MID = 121;
        var proStat = root.getAttribute('data-pro-stat');
        var proLabel = root.getAttribute('data-pro-label');
        if (proStat == null) proStat = '~50%';
        if (proLabel == null) proLabel = 'of your health outcomes';
        var centerWrap = root.querySelector('.us-sunburst__center');
        var pro, proGenes, proRest, proLblRest, lastT = -1, lastCenter = '';
        function arcPath(a0, a1, r, ccw) {
          var large = Math.abs(a1 - a0) > 180 ? 1 : 0;
          return 'M' + f(polar(r, a0)) + 'A' + r + ' ' + r + ' 0 ' + large + ' ' + (ccw ? 0 : 1) + ' ' + f(polar(r, a1));
        }
        function proText(cls, pathId, label) {
          var tx = el('text', { 'class': 'us-sunburst__pro-label ' + cls });
          var tp = el('textPath', { startOffset: '50%' });
          tp.setAttribute('href', '#' + pathId);
          tp.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + pathId);
          tp.textContent = label;
          tx.appendChild(tp);
          return tx;
        }
        function buildPro() {
          pro = el('g', { 'class': 'us-sunburst__pro', 'aria-hidden': 'true' });
          proGenes = el('path', { 'class': 'us-sunburst__pro-genes' });
          proRest = el('path', { 'class': 'us-sunburst__pro-rest' });
          pro.appendChild(proRest); pro.appendChild(proGenes);
          var gid = busKey + '-lblg', rid = busKey + '-lblr';
          pro.appendChild(el('path', { id: gid, d: arcPath(30, 150, PRO_MID), fill: 'none' }));
          pro.appendChild(el('path', { id: rid, d: arcPath(330, 210, PRO_MID, true), fill: 'none' }));
          pro.appendChild(proText('us-sunburst__pro-lgenes', gid, root.getAttribute('data-pro-genes') || 'Your genes'));
          proLblRest = proText('us-sunburst__pro-lrest', rid, root.getAttribute('data-pro-rest') || 'Lifestyle & environment');
          pro.appendChild(proLblRest);
          svg.appendChild(pro);
        }
        function paintPro(t, q) {
          if (!pro) return;
          var fade = q > 0 ? Math.max(0, 1 - q / 0.12) : 1;
          pro.style.opacity = fade.toFixed(3);
          pro.style.visibility = fade === 0 ? 'hidden' : '';
          if (fade === 0 || t === lastT) { lastT = t; return; }
          lastT = t;
          var a1 = 180 + 180 * t;
          proGenes.setAttribute('d', sector(0, Math.min(a1, 359.98), PRO_IN, PRO_OUT));
          if (360 - a1 > 0.75) {
            proRest.setAttribute('d', sector(a1, 360, PRO_IN, PRO_OUT));
            proRest.style.display = '';
          } else {
            proRest.style.display = 'none';
          }
          proLblRest.style.opacity = Math.max(0, 1 - t * 2.5).toFixed(3);
        }
        function setCenter(mode) {
          if (mode === lastCenter) return;
          lastCenter = mode;
          if (centerWrap) centerWrap.classList.toggle('is-pro', mode === 'pro');
          root.classList.toggle('is-act2', mode === 'count');
          if (mode === 'pro') {
            if (centerWrap) {
              centerWrap.classList.toggle('is-pro-nostat', !proStat);
              centerWrap.classList.toggle('is-pro-nolabel', !proLabel);
            }
            if (centerNum) centerNum.textContent = proStat;
            if (centerLbl) centerLbl.textContent = proLabel;
          } else if (centerLbl) {
            centerLbl.textContent = origLbl;
          }
        }

        var allTicks = [], catStart = [], grpStart = [];
        catEls.forEach(function (c, ci) {
          catStart[ci] = allTicks.length;
          if (grpStart[c.group] === undefined) grpStart[c.group] = allTicks.length;
          for (var i = 0; i < c.ticks.length; i++) allTicks.push(c.ticks[i]);
        });
        var totalTicks = allTicks.length;

        function revealSweep(sweep) {
          for (var i = 0; i < totalTicks; i++) allTicks[i].classList.toggle('is-shown', i < sweep);
          catEls.forEach(function (c, ci) { c.arc.classList.toggle('is-shown', catStart[ci] < sweep); });
          groupEls.forEach(function (g, gi) { g.arc.classList.toggle('is-shown', grpStart[gi] < sweep); });
          Array.prototype.forEach.call(legendItems, function (li) { li.classList.toggle('is-shown', catStart[+li.getAttribute('data-cat')] < sweep); });
          Array.prototype.forEach.call(legendGroups, function (li) { li.classList.toggle('is-shown', grpStart[+li.getAttribute('data-group')] < sweep); });
          if (centerNum) centerNum.textContent = sweep >= totalTicks ? origNum : String(sweep);
        }

        var soonEls = root.querySelectorAll('.us-sunburst__soon-item');
        var nSoon = soonEls.length;
        function revealTail(p) {
          var done = p >= COMPLETE_AT;
          root.classList.toggle('is-complete', done);
          if (!nSoon) return;
          var r = done ? (p - COMPLETE_AT) / Math.max(0.001, (1 - COMPLETE_AT) * 0.75) : 0;
          for (var i = 0; i < nSoon; i++) {
            soonEls[i].classList.toggle('is-shown', done && r >= i / nSoon);
          }
        }
        function syncLedeOverhang() {
          var cell = root.querySelector('.us-sunburst__lede');
          var act2El = root.querySelector('.us-sunburst__l-act2');
          if (!cell || !act2El) return;
          var over = cell.getBoundingClientRect().height - act2El.getBoundingClientRect().height;
          root.style.setProperty('--us-lede-overhang', Math.max(0, over).toFixed(1) + 'px');
        }

        function measure() {
          syncLedeOverhang();
          lastShift = null; lastHead = null;
          var sweepPx = hasSoon ? Math.max(window.innerHeight * 3.2, 2000)
                      : hasTail ? Math.max(window.innerHeight * 2.8, 1750)
                                : Math.max(window.innerHeight * 2.6, 1600);
          if (!hasAct1) sweepPx *= (SWEEP_END - ACT1_SHARE) / SWEEP_END;
          track.style.height = (stage.offsetHeight + sweepPx) + 'px';
          geo.top = parseFloat(getComputedStyle(stage).top) || 0;
          geo.range = track.offsetHeight - stage.offsetHeight;
        }
        function paintScroll() {
          var pinned = geo.top - track.getBoundingClientRect().top;
          var p = geo.range > 0 ? Math.min(1, Math.max(0, pinned / geo.range)) : 0;
          var t = !hasAct1 ? 1 : (p <= PRO_READ ? 0 : Math.min(1, (p - PRO_READ) / (PRO_END - PRO_READ)));
          t = t * t * (3 - 2 * t);
          var q = Math.min(1, Math.max(0, (p - PRO_END) / (SWEEP_END - PRO_END)));
          paintPro(t, q);
          var sweep = Math.round(q * totalTicks);
          if (sweep !== lastSweep) { lastSweep = sweep; revealSweep(sweep); }
          var done = p >= COMPLETE_AT;
          if (done || lastDone !== false) { lastDone = done; revealTail(p); }
          setCenter(!hasAct1 || q > 0 ? 'count' : 'pro');
          trackCopy(q > 0);
        }
        function enable() {
          if (scrollActive) return;
          scrollActive = true; lastSweep = -1; lastT = -1; lastCenter = ''; lastDone = null;
          root.classList.add('is-scroll');
          if (hasAct1 && !pro) buildPro();
          measure(); scrollBus.set(busKey, paintScroll);
        }
        function disable() {
          if (!scrollActive) return;
          scrollActive = false; lastSweep = -1; lastCenter = ''; lastDone = null;
          root.classList.remove('is-scroll');
          root.classList.remove('is-act2');
          root.classList.remove('is-complete');
          for (var si = 0; si < nSoon; si++) soonEls[si].classList.remove('is-shown');
          if (centerWrap) centerWrap.classList.remove('is-pro');
          track.style.height = ''; scrollBus.set(busKey, null);
          shiftCopy(0);
          clearActive();
        }
        function evalMode() { if (mq.matches && root.getAttribute('data-us-sunburst-scroll') !== 'false') enable(); else disable(); }

        evalMode();
        (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(evalMode);
        var rz;
        window.addEventListener('resize', function () {
          if (!scrollActive || rz) return;
          rz = requestAnimationFrame(function () { rz = 0; measure(); paintScroll(); });
        });
      }
    });
  }

  function initPageTone() {
    var zones = document.querySelectorAll('[data-us-nav-tone="dark"].us-surface--dark');
    if (!zones.length) { scrollBus.set('pagetone', null); return; }
    var el = document.documentElement;
    var dark = false;
    el.setAttribute('data-us-page-tone', 'light');
    scrollBus.set('pagetone', function () {
      var h = window.innerHeight;
      var inTop = h * 0.34, inBot = h * 0.66;
      var covering = false, touching = false;
      for (var i = 0; i < zones.length; i++) {
        var r = zones[i].getBoundingClientRect();
        if (r.top <= inTop && r.bottom >= inBot) covering = true;
        if (r.top < inBot && r.bottom > inTop) touching = true;
      }
      var next = dark ? touching : covering;
      if (next === dark) return;
      dark = next;
      el.setAttribute('data-us-page-tone', dark ? 'dark' : 'light');
    });
  }

  function initFooterTone() {
    var foot = document.querySelector('.us-footer');
    if (!foot) return;
    var root = foot.closest('.us-footer-root') || foot;
    var footTop = root.getBoundingClientRect().top + window.scrollY;
    var zones = document.querySelectorAll('[data-us-nav-tone="dark"]');
    for (var i = 0; i < zones.length; i++) {
      var zoneBottom = zones[i].getBoundingClientRect().bottom + window.scrollY;
      if (Math.abs(zoneBottom - footTop) < 48) {
        foot.classList.add('us-footer--light');
        return;
      }
    }
  }

  var consentLinksWired = false;
  function initConsentPolicyLinks() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root === '/') return;
    if (consentLinksWired) { return; }
    consentLinksWired = true;
    var prefix = root.replace(/\/$/, '');

    function rewrite(scope) {
      if (!scope || !scope.querySelectorAll) return;
      var links = scope.querySelectorAll('a[href*="/policies/"]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.host !== window.location.host) continue;
        if (a.pathname.indexOf(prefix + '/') === 0) continue;
        a.href = a.origin + prefix + a.pathname + a.search + a.hash;
      }
    }
    function sweep() {
      var nodes = document.querySelectorAll('[id^="shopify-pc"]');
      for (var i = 0; i < nodes.length; i++) rewrite(nodes[i]);
    }

    sweep();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.id && n.id.indexOf('shopify-pc') === 0) || n.querySelector && n.querySelector('[id^="shopify-pc"]')) {
            sweep();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function initOptOutReturn() {
    var here = (window.location.pathname + window.location.search).replace(/^\/+/, '/');
    var forms = document.querySelectorAll('form[action$="/dns_opt_out"]');
    for (var i = 0; i < forms.length; i++) {
      var field = forms[i].querySelector('input[name="return_to"]');
      if (field && !field.value) field.value = here;
    }
  }

  function initSignup() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-us-signup]'), function (form) {
      if (form.hasAttribute('data-us-signup-wired')) return;
      form.setAttribute('data-us-signup-wired', '');
      var input = form.querySelector('input[type="email"], .us-footerx__input');
      if (!input) return;
      form.classList.add('is-enhanced');
      function sync() { form.classList.toggle('has-value', input.value.trim() !== ''); }
      input.addEventListener('input', sync);
      sync();
    });
  }

  function klDedupePlaceholders(box) {
    var fields = box.querySelectorAll('[data-testid="form-row"] input[placeholder], [data-testid="form-row"] textarea[placeholder]');
    Array.prototype.forEach.call(fields, function (el) {
      if (el.hasAttribute('data-us-kl-ph')) return;
      var lab = el.id ? box.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]') : null;
      if (!lab) {
        var comp = el.closest('[data-testid="form-component"]');
        lab = comp && comp.querySelector('label, legend');
      }
      if (!lab) return;
      var norm = function (s) { return (s || '').replace(/[*:\s]+/g, ' ').trim().toLowerCase(); };
      if (norm(lab.textContent) !== norm(el.getAttribute('placeholder'))) return;
      el.setAttribute('data-us-kl-ph', '');
      if (el.getAttribute('role') === 'combobox' || el.hasAttribute('aria-controls')) {
        el.setAttribute('placeholder', 'Select one');
      } else {
        el.removeAttribute('placeholder');
      }
    });
  }

  function initFooterKlaviyo() {
    Array.prototype.forEach.call(document.querySelectorAll('.us-footerx__klaviyo'), function (box) {
      if (box.hasAttribute('data-us-kl-wired')) return;
      box.setAttribute('data-us-kl-wired', '');
      box.classList.add('is-collapsible');
      function open() {
        if (box.classList.contains('is-open')) return;
        box.classList.add('is-open');
      }
      box.addEventListener('focusin', open);
      box.addEventListener('pointerdown', open);
      box.addEventListener('keydown', open);

      klDedupePlaceholders(box);
      if (window.MutationObserver) {
        new MutationObserver(function () { klDedupePlaceholders(box); })
          .observe(box, { childList: true, subtree: true });
      }
    });
  }

  function initPcardVariants() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-us-pcard-opts]'), function (group) {
      if (group.hasAttribute('data-us-opts-wired')) return;
      group.setAttribute('data-us-opts-wired', '');

      var card = group.closest('.us-pcards__card');
      if (!card) return;

      var priceEl = card.querySelector('[data-us-pcard-price]');
      var idInput = card.querySelector('.us-pcards__form [name="id"]');
      var cta = card.querySelector('.us-pcards__cta');
      var ctaHref = cta ? cta.getAttribute('href') || '' : '';
      var ctaBase = ctaHref.split('?')[0].split('#')[0];
      var ctaVariable = ctaBase.indexOf('/products/') !== -1;

      group.addEventListener('change', function (e) {
        var el = e.target;
        if (!el || !el.value) return;

        var source = el.options ? el.options[el.selectedIndex] : el;
        var price = source && source.getAttribute('data-us-price');
        if (priceEl && price) priceEl.textContent = price;
        if (idInput) idInput.value = el.value;
        if (cta && ctaVariable) cta.setAttribute('href', ctaBase + '?variant=' + el.value);
      });
    });
  }

  function initPcardTabs() {
    var mq = window.matchMedia('(max-width: 749px)');

    Array.prototype.forEach.call(document.querySelectorAll('[data-us-pcard-tabs]'), function (tablist) {
      if (tablist.hasAttribute('data-us-tabs-wired')) return;

      var section = tablist.closest('.us-pcards');
      if (!section) return;

      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[data-us-pcard-tab]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-us-pcard-panel]'));
      if (tabs.length < 2 || tabs.length !== panels.length) return;

      tablist.setAttribute('data-us-tabs-wired', '');
      var current = 0;

      function select(i) {
        current = i;
        for (var n = 0; n < tabs.length; n++) {
          var on = n === i;
          tabs[n].classList.toggle('is-active', on);
          panels[n].classList.toggle('is-active', on);
          if (mq.matches) {
            tabs[n].setAttribute('aria-selected', on ? 'true' : 'false');
            tabs[n].setAttribute('tabindex', on ? '0' : '-1');
          }
        }
      }

      function applyRoles() {
        if (mq.matches) {
          tablist.setAttribute('role', 'tablist');
          var label = section.querySelector('.us-pcards__heading');
          if (label && label.id) tablist.setAttribute('aria-labelledby', label.id);
          for (var n = 0; n < tabs.length; n++) {
            tabs[n].setAttribute('role', 'tab');
            tabs[n].setAttribute('aria-controls', panels[n].id);
            panels[n].setAttribute('role', 'tabpanel');
            panels[n].setAttribute('aria-labelledby', tabs[n].id);
          }
          select(current);
        } else {
          tablist.removeAttribute('role');
          tablist.removeAttribute('aria-labelledby');
          for (var m = 0; m < tabs.length; m++) {
            tabs[m].removeAttribute('role');
            tabs[m].removeAttribute('aria-controls');
            tabs[m].removeAttribute('aria-selected');
            tabs[m].removeAttribute('tabindex');
            panels[m].removeAttribute('role');
            panels[m].removeAttribute('aria-labelledby');
          }
        }
      }

      tablist.addEventListener('click', function (e) {
        var t = e.target.closest('[data-us-pcard-tab]');
        if (!t) return;
        var i = tabs.indexOf(t);
        if (i > -1) select(i);
      });

      tablist.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i === -1) return;
        var next = -1;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === -1) return;
        e.preventDefault();
        select(next);
        tabs[next].focus();
      });

      if (mq.addEventListener) mq.addEventListener('change', applyRoles);
      else if (mq.addListener) mq.addListener(applyRoles);

      applyRoles();
      select(0);
    });
  }

  function init() { initReveals(); initBuy(); initStickyCta(); initNavTone(); initHiwStack(); initDropdown(); initHeaderPanel(); initPageTone(); initGenomeSunburst(); initHeroSpotlight(); initFooterTone(); initFooterSpotlight(); initSignup(); initFooterKlaviyo(); initConsentPolicyLinks(); initOptOutReturn(); initPcardVariants(); initPcardTabs(); }

  window.USCore = { reinit: init };
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
